import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "locales/en.json";
import translationVI from "locales/vi.json";
import { getCookie } from "utils/get-lang";

const resources = {
  en: { translation: translationEN },
  vi: { translation: translationVI },
};

i18next.use(initReactI18next).init({
  lng: getCookie("zlanguage") === "en" ? "en" : "vi", // if you're using a language detector, do not define the lng option
  debug: true,
  resources: resources
});

export default i18next;

// import { initReactI18next } from 'react-i18next';
// import i18n from 'i18next';
// import Backend from 'i18next-http-backend';

// import { getCookie } from 'utils/get-lang';

// // don't want to use this?
// // have a look at the Quick start guide
// // for passing in lng and translations on init

// i18n
//   // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
//   // learn more:
//   .use(Backend)
//   // detect user language
//   // learn more: https://github.com/i18next/i18next-browser-languageDetector
//   .use(initReactI18next)
//   // init i18next
//   // for all options read: https://www.i18next.com/overview/configuration-options
//   .init({
//     fallbackLng: getCookie('zlanguage') === 'en' ? 'en' : 'vi',
//     debug: false,
//     backend: {
//       loadPath: '/stc/h5/locales/{{lng}}/{{ns}}.json',
//     },
//     react: {
//       useSuspense: false,
//     },

//     interpolation: {
//       escapeValue: false, // not needed for react as it escapes by default
//     },
//   });

// export default i18n;
